import { render, staticRenderFns } from "./FilterBody.vue?vue&type=template&id=66126a33&scoped=true"
import script from "./FilterBody.vue?vue&type=script&lang=js"
export * from "./FilterBody.vue?vue&type=script&lang=js"
import style0 from "./FilterBody.vue?vue&type=style&index=0&id=66126a33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66126a33",
  null
  
)

export default component.exports